import { API_BASE_URL } from '@/services/api';

/**
 * Envia relatório de erro do frontend para o backend,
 * que por sua vez notifica o Telegram do administrador.
 * 
 * Usa fire-and-forget (não bloqueia, não mostra toast de erro se falhar).
 */
let lastErrorTime = 0;
let errorCount = 0;
const ERROR_THROTTLE_MS = 2000;   // Mínimo 2s entre erros
const MAX_ERRORS_PER_MIN = 10;    // Máximo 10 erros por minuto

export function reportErrorToTelegram({ error, stack = '', component = '', url = '' }) {
  try {
    // Throttle para não floodar o Telegram
    const now = Date.now();
    if (now - lastErrorTime < ERROR_THROTTLE_MS) return;
    if (errorCount >= MAX_ERRORS_PER_MIN) return;
    
    lastErrorTime = now;
    errorCount++;
    
    // Reseta contador a cada minuto
    setTimeout(() => { errorCount = Math.max(0, errorCount - 1); }, 60000);

    // Dados do usuário logado
    let userInfo = 'Não autenticado';
    try {
      const stored = localStorage.getItem('user');
      if (stored) {
        const user = JSON.parse(stored);
        userInfo = `${user.role || '?'} | ID: ${user.id || '?'} | ${user.name || user.email || ''}`;
      }
    } catch (e) {
      // Ignora
    }

    const baseUrl = localStorage.getItem('API_URL') || API_BASE_URL;
    const reportUrl = `${baseUrl.replace(/\/$/, '')}/error-report`;

    // Fire-and-forget via fetch (não usa apiRequest para evitar loop de erros)
    fetch(reportUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        error: error?.substring?.(0, 500) || String(error),
        stack: stack?.substring?.(0, 1000) || '',
        component,
        url,
        user: userInfo
      })
    }).catch(() => {
      // Silencia completamente — não pode causar novos erros
    });

  } catch (e) {
    // Proteção total contra loops infinitos
  }
}
